import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  openFlg: false,
  key: null
}

// sliceを生成
export const dialogSlice = createSlice({
  // SliceごとにStore、Reducer、Actionを管理できる
  name: 'dialog', //  Sliceの名称 ※ stateの名前ではない(変更する場合でもここだけ変えれば良い)
  initialState,
  // Stateに対して許可する更新処理を定義する場所
  reducers: {
    toggleDialog: (state, action) => {
      return {
        ...state,
        openFlg: action.payload.flg,
        items: action.payload.key
      }
    },
  },
})

export const { toggleDialog } = dialogSlice.actions
export default dialogSlice.reducer
